/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect } from 'react';
// utils
import { url } from 'utils/urls';
// material
import { TextField } from '@insticator/insticator-ui'
import { ReactComponent as ComposeIcon } from 'assets/icons/compose.svg'
import { ReactComponent as NoneIcon } from 'assets/icons/none.svg'
import Space from 'material/space/space';
import { ConfigToggle, SectionGroupV2 } from 'material/expandablesection/v2'
// styles
import injectSheet from 'react-jss'
import styles from './headertitle_styles'
import PreviewConfig from 'material/previewconfig/previewconfig'
import { useDispatch } from 'react-redux';

import { ReactComponent as Comment1Icon } from 'assets/icons/comment-1.svg'
import { ReactComponent as Comment2Icon } from 'assets/icons/comment-2.svg'
import { ReactComponent as Comment3Icon } from 'assets/icons/comment-3.svg'
import { ReactComponent as Comment4Icon } from 'assets/icons/comment-4.svg'
import { ReactComponent as Comment5Icon } from 'assets/icons/comment-5.svg'
import { setCommentingConfigSectionValid } from 'state/slices/commentingv2';

const icons = {
  DOUBLE_BUBBLE_RECT_DARK: <Comment1Icon />,
  SINGLE_BUBBLE_RECT_LIGHT: <Comment2Icon />,
  SINGLE_BUBBLE_ROUND_DARK: <Comment3Icon />,
  SINGLE_BUBBLE_ROUND_LIGHT: <Comment4Icon />,
  SINGLE_BUBBLE_RECT_DARK: <Comment5Icon />,
  NONE: <NoneIcon />
}

/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: GENERAL SECTION : HEADER TITLE ~~~~~~~~~~ ========== */
const HeaderTitle = injectSheet(styles)((props) => {

  const dispatch = useDispatch()

  const { useHeader, headerIcon, headerTitle, useHeaderCounter, useHeaderBorder, onChange } = props

  const handleIconChange = icon =>  onChange('headerIcon', icon)

  useEffect(() => {
    if(headerTitle) dispatch(setCommentingConfigSectionValid({configName: 'generalConfig', isValid: true}))
    else dispatch(setCommentingConfigSectionValid({configName: 'generalConfig', isValid: false}))
  }, [dispatch, headerTitle])


  return (
    <SectionGroupV2 
      indented={true} 
      klass={`headertitle ${props.classes.headertitle}`} 
      title={'Header title'} 
      rowGap={32} 
      direction={'column'}>
        <Space gap={48}>
          <ConfigToggle 
            title={'Enable header'}
            description={'Customize the title with your own phrase and imagery.'}
            checked={useHeader}
            indented={false}
            onChange={val => onChange('useHeader', !useHeader)}
          >
          <Space direction={'column'} gap={16}>
            <TextField 
              type={`text`} 
              name={`headerTitle`} 
              icon={<ComposeIcon />}
              value={headerTitle} 
              handleChange={e => onChange('headerTitle', e.target.value)}
              placeholder={``} 
              required
              valid={!!headerTitle}
              maxLength={128}
            />
            <p>Choose an icon style </p>
            <Space klass={'headericons'}>
              {Object.keys(icons).map(key => (
                  <div className={`icon selected-${headerIcon === key}`} onClick={() => handleIconChange(key)}>
                   {icons[key]}
                 </div>
              ))}
            </Space>
            <ConfigToggle 
              title={'Enable header border'}
              checked={useHeaderBorder}
              onChange={val => onChange('useHeaderBorder', !useHeaderBorder)}
              gap={16}
            />
            <ConfigToggle 
              title={'Enable counter'}
              checked={useHeaderCounter}
              onChange={val => onChange('useHeaderCounter', !useHeaderCounter)}
              gap={16}
            />
          </Space>
          </ConfigToggle>
          <PreviewConfig>
            <Space>
              {headerIcon !== 'NONE' && icons[headerIcon]}
              <h3>{headerTitle} {useHeaderCounter && <span className='count'>124</span>}</h3>
            </Space>
          </PreviewConfig>
        </Space>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default HeaderTitle;